import { SPECIAL_PRODUCT_TYPES } from 'swag-common/constants/product.constants';
export let STEPS = /*#__PURE__*/function (STEPS) {
  STEPS["BOX_INTRODUCTION_INFO"] = "BOX_INTRODUCTION_INFO";
  STEPS["BOX_NAMING"] = "BOX_NAMING";
  STEPS["BOX_TYPE_SELECTION"] = "BOX_TYPE_SELECTION";
  STEPS["CUSTOM_BOX_SELECTION"] = "CUSTOM_BOX_SELECTION";
  STEPS["FULLY_CUSTOM_BOX_SELECTION"] = "FULLY_CUSTOM_BOX_SELECTION";
  STEPS["COLORED_BOX_SELECTION"] = "COLORED_BOX_SELECTION";
  STEPS["BROWN_BOX_SELECTION"] = "BROWN_BOX_SELECTION";
  STEPS["SELECT_PRODUCTS_FOR_BOX"] = "SELECT_PRODUCTS_FOR_BOX";
  STEPS["SELECT_ADDONS_FOR_BOX"] = "SELECT_ADDONS_FOR_BOX";
  return STEPS;
}({});
export const BOX_TYPE_TO_STEP = {
  [SPECIAL_PRODUCT_TYPES.CUSTOM_BOX]: STEPS.CUSTOM_BOX_SELECTION,
  [SPECIAL_PRODUCT_TYPES.FULLY_CUSTOM_BOX]: STEPS.FULLY_CUSTOM_BOX_SELECTION,
  [SPECIAL_PRODUCT_TYPES.COLORED_BOX]: STEPS.COLORED_BOX_SELECTION,
  [SPECIAL_PRODUCT_TYPES.BROWN_BOX]: STEPS.BROWN_BOX_SELECTION
};
export const BOX_TYPE_SELECTIONS = {
  [STEPS.COLORED_BOX_SELECTION]: STEPS.COLORED_BOX_SELECTION,
  [STEPS.FULLY_CUSTOM_BOX_SELECTION]: STEPS.FULLY_CUSTOM_BOX_SELECTION,
  [STEPS.CUSTOM_BOX_SELECTION]: STEPS.CUSTOM_BOX_SELECTION,
  [STEPS.BROWN_BOX_SELECTION]: STEPS.BROWN_BOX_SELECTION
};
export const initialState = {
  boxName: '',
  boxInfoStepCompleted: false,
  selectedBoxType: null,
  selectedBackButtonOnStep: null,
  selectedForwardButtonOnStep: null,
  coloredBoxInfo: null,
  customBoxInfo: null,
  fullyCustomBoxInfo: null,
  brownBoxInfo: null,
  customBoxLogoLoading: false,
  brownBoxLogoLoading: false,
  currentBoxesQuantity: null,
  productCardSelections: {},
  addonCardSelections: {},
  editingBoxTypeBoxId: null,
  editQuantityInCartItemData: null,
  editedQuantityInCartData: null,
  editingQuantityInCart: null,
  editingBoxNameBoxId: null,
  editBoxBuilderItemsId: null
};
export const ANIMATION_TRANSITION_TIME = 400;